<template>
  <div>
    <BlogArticle
      v-for="(article, index) of articles"
      :article="article"
      :key="index"
    />
  </div>
</template>

<script>
import useArticle from '@/compositions/useArticle';
import BlogArticle from '@/components/Company/BlogArticle';

export default {
  name: 'BlogArticles',
  components: { BlogArticle },

  setup() {
    const { articles } = useArticle();

    return {
      articles,
    };
  },
};
</script>

<style scoped>

</style>
